import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { CURATION_STATUS } from 'domains/seller-inbound/constants'


const propTypes = {
  curation_status: PropTypes.string
}

/**
 * To give nice look on Seller Inbound `curation_status`.
 * It maps `curation_status` to certain style and pass to `StatusBadge`.
 * @param {string} received_status seller type. available values
 * - `pending`
 * - `curated`
 */
const SellerInboundCurationStatusBadge = ({ curation_status }) => {

  const colorMap = {
    [CURATION_STATUS.PENDING] : 'warning',
    [CURATION_STATUS.CURATED] : 'success'
  }

  const color = colorMap[curation_status] || 'default'

  return <StatusBadge color={ color } label={ curation_status } />
}

SellerInboundCurationStatusBadge.propTypes = propTypes

export default SellerInboundCurationStatusBadge